import { Badge, Button, Text } from '@chakra-ui/react'
import type { InsurerOrganizationUnitDiscount } from 'BrokerTsLib/src/dtos'

export const Discounts = ({
  discounts,
  onClick,
  isDisabled,
}: {
  discounts: InsurerOrganizationUnitDiscount[]
  onClick: () => void
  isDisabled?: boolean
}) => {
  return (
    <>
      {discounts.map((discount) =>
        isDisabled ? (
          <Badge>
            {`${discount.maxDiscount}\u00A0${discount.unit} ${discount.name}`}
          </Badge>
        ) : (
          <Button
            key={discount.insuranceCategoryDiscountId}
            size="sm"
            variant="solid"
            onClick={onClick}
            bgColor={discount.valid ? 'gray.100' : 'gray.50'}
            color={discount.valid ? 'gray.800' : 'gray.400'}
          >
            <Text>{`${discount.maxDiscount}\u00A0${discount.unit} ${discount.name}`}</Text>
          </Button>
        ),
      )}
    </>
  )
}
